"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StronglyTypedSearchAPI = void 0;
var searchAPI_1 = require("./searchAPI");
var StronglyTypedSearchAPI = /** @class */ (function (_super) {
    __extends(StronglyTypedSearchAPI, _super);
    /**
     * Initializes a new instance of the SearchAPI class.
     * @param [options] The parameter options
     */
    function StronglyTypedSearchAPI(options) {
        return _super.call(this, options) || this;
    }
    /**
     * Transforms a generic search request into an Azure Cognitive Search request, performs the search
     * and transforms the Azure Cogintive Search result into a generic search result.
     * @summary Use a generic search request to query Azure Cognitive Search
     * @param genericSearchRequest GenericSearchRequest object
     * @returns Promise<Models.AzureSearchResponse>
     */
    StronglyTypedSearchAPI.prototype.azureSearchTyped = function (genericSearchRequest) {
        return this.azureSearch(JSON.stringify(genericSearchRequest));
    };
    /**
     * Transforms a generic autocomplete request into an Azure Cognitive Search request, performs the
     * search and transforms the Azure Cogintive Search result into a generic autocomplete result.
     * @summary Get autocomplete results for a query string
     * @param genericAutocompleteRequest GenericAutocompleteRequest object
     * @returns Promise<Models.AzureAutocompleteResponse>
     */
    StronglyTypedSearchAPI.prototype.azureAutocompleteTyped = function (genericAutocompleteRequest) {
        return this.azureAutocomplete(JSON.stringify(genericAutocompleteRequest));
    };
    return StronglyTypedSearchAPI;
}(searchAPI_1.SearchAPI));
exports.StronglyTypedSearchAPI = StronglyTypedSearchAPI;
